export default __webpack_public_path__ + "static/The guardian-908fd25518bdd4f36bde92b747050bb0.svg";